








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {Logo} from '@/components/Logo';

@Component({
  name: 'Contacts',
  components: { Logo },
})
export default class Contacts extends Vue {
  @Prop([String]) private readonly phone!: string;
  @Prop([String]) private readonly mail!: string;
}
